import KoIcon from '@kwapio/icons';
import styles from './order.module.scss';
import { KoAffix, KoButton, KoDescription, KoDropdown, KoForm, KoLoader, KoModal, KoText, KoTitle} from 'packages';
import React, {   useEffect, useState } from 'react';
import { Outlet, useMatch } from 'react-router';
import ProductCurd from './products/productList/curd';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';





const OrdersPage=()=>{

  const [loading ] = useState(false);
  const accountById = useSelector((state) => state?.accountById);
  const accountDetails = accountById["data"];
  const [addProduct, setModalAddProduct] = useState(false);
  const [form] = KoForm.useForm();
  const [productForm] = KoForm.useForm();
  // const [categoryForm] = KoForm.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [filter, setFilter] = useState("Last 7 days");
  // const [ addCategory,setModalAddCategory] =useState(false);

  const seletedDate = searchParams.get("date");
  const dateRangeOptions = [
    {
      key: "today",
      label: "Today"
    },
    {
      key: "yesterday",
      label: "Yesterday"
    },
    {
      key: "currentWeek",
      label: "This Week"
    },
    {
      key: "lastWeek",
      label: "Last Week"
    },
    {
      key: "last7Days",
      label: "Last 7 Days"
    },
    {
      key: "currentMonth",
      label: "This Month"
    },
    {
      key: "lastMonth",
      label: "Last Month"
    },
    {
      key: "last3Months",
      label: "Last 3 Months"
    },
    {
      key: "last6Months",
      label: "Last 6 Months"
    },
    {
      key: "currentYear",
      label: "This Year"
    },
    {
      key: "lastYear",
      label: "Last Year"
    }
  ];

  useEffect(() => {
    if (seletedDate) {
      let item = dateRangeOptions.find((item) => item.key === seletedDate);
      setFilter(item?.label);
    }
  }, [seletedDate]);

  const getDashboardData = ({ key }) => {
    let item = dateRangeOptions.find((item) => item.key === key);
    const newParams = new URLSearchParams(searchParams);
    newParams.set("date", key);
    setSearchParams(newParams);
    setFilter(item?.label);
  };

  // const handleFinish = useCallback(
  //   async(values) => {
  //     try {
  //       if (!values) return;
  //       setLoading(true);

  //       const payload = {
  //         ...values,
  //         categoryId: KoNano("CAT")
  //       };

  //       console.log("Category Values:", payload);
  //       await OrdersAPI.createCategory(payload);

  //       form.resetFields();
  //       KoToast.success("Successfully Created");
  //     } catch (error) {
  //       console.error(error);
  //       KoToast.error("Something Went Wrong");
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [form]
  // );

  const datefilter = useMatch("/workspace/:id/orders/dashboard");
  const showDropdown = !!datefilter;
  // const addcustomer = useMatch("/workspace/:id/orders/products");
  // const showAddCategory = !!addcustomer;

  return(
    <>
      <div className={`${styles.wrapper} profileSection`}>
        {loading && <KoLoader />}
        <KoAffix top={50}>
          <div className={styles.dashboardHeader}>
            <div className={styles.headerWrapper}>
              <div className={styles.header}>
                <div className={styles.greetings}>
                  <KoTitle ellipsis={true} text={"Welcome Back Jaya"} level={1} />
                  <KoButton
                    className={styles.orgclass}
                    label={`${accountDetails?.companyName}`}
                    type="text"
                    icon={<KoIcon name={"OrgOutlined"} width={18} height={18} />}
                  />
                </div>
                <div className={styles.addProduct}>
                  {showDropdown&&<KoDropdown
                    placement="bottomRight"
                    overlayClassName={"overlayClassName"}
                    menu={{
                      items: dateRangeOptions,
                      onClick: getDashboardData
                    }}
                  >
                    <div className={styles.dropdown}>
                      <KoText text={filter} />
                      <KoIcon name={"DownArrowOutlined"} width={12} height={12} />
                    </div>
                  </KoDropdown>}
                  {/* {showAddCategory && <KoButton
                    onClick={() => setModalAddCategory(true)}
                    type="primary"
                    icon={<KoIcon color="#FFF" name="PlusOutlined" />}
                    label={`Add Category`}
                  />
                  } */}
                  <KoButton
                    onClick={() => setModalAddProduct(true)}
                    type="primary"
                    icon={<KoIcon color="#FFF" name="PlusOutlined" />}
                    label={`Add Product`}
                  />

                </div>
              </div>
                
            </div>
            <div className={styles.description}>
              <KoDescription
                text={`Here is a summary of your store`}
              />
            </div>
          </div>
        </KoAffix>
      
        <Outlet/>
      </div>
    
      <KoModal
        title={`Add Product`}
        centered
        afterClose={() => {
          productForm.resetFields();
        }}
        open={addProduct}
        handleOk={() => {
          setModalAddProduct(false);
        }}
        onClose={() => {
          setModalAddProduct(false);
          productForm.resetFields();
        }}
        width={"65vw"}
        maskClosable={false}
        footer={[
          <KoButton
            key="cancel"
            label="Cancel"
            onClick={() => {
              setModalAddProduct(false);
              productForm.resetFields();
            }}
          />,
          <KoButton
            key="create"
            loading={loading}
            type="primary"
            label={`Create`}
            onClick={() => form.submit()}
          />
        ]}
      >
        {loading && <KoLoader circle={false} />}
        <ProductCurd form={productForm} />
      </KoModal>
      

      

    </>
  );
};
export default OrdersPage;